var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "3", md: "3" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    {
                      attrs: { color: "primary", dense: "", dark: "", flat: "" }
                    },
                    [_c("span", [_vm._v("Create")])]
                  ),
                  _c(
                    "v-container",
                    [
                      _c("create-candled-rack-eggs", {
                        ref: "createCandedRackEggs",
                        attrs: { "default-data": _vm.editCandledRackEggs },
                        on: {
                          "update:defaultData": function($event) {
                            _vm.editCandledRackEggs = $event
                          },
                          "update:default-data": function($event) {
                            _vm.editCandledRackEggs = $event
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "6", md: "6" } },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-toolbar",
                    {
                      attrs: { color: "primary", dense: "", dark: "", flat: "" }
                    },
                    [_c("span", [_vm._v("List")])]
                  ),
                  _c(
                    "v-container",
                    [
                      _c("table-candled-rack-eggs", {
                        on: {
                          updated: function($event) {
                            return _vm.$refs.createCandedRackEggs.getIncubatorIds()
                          },
                          edit: item => (_vm.editCandledRackEggs = item)
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }